"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastDescription = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ToastPrimitive = require("@radix-ui/react-toast");
const classNames_1 = require("../../../../../utils/classNames");
exports.ToastDescription = (0, react_1.forwardRef)(({ className, ...props }, ref) => ((0, jsx_runtime_1.jsx)(ToastPrimitive.Description, { ref: ref, className: (0, classNames_1.cn)('text-sm opacity-90', className), ...props })));
